import React, { useEffect } from "react";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import { connect } from "react-redux";
import ModuleTable from "../../components/ModuleTable";
import { useHistory } from "react-router-dom";

import { getAllModuleListAction } from "../../store/actions";

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Конструктор модулей",
    link: "#"
  }
];

const ModuleList = ({ getModulesList, modules }) => {
  const history = useHistory();
  useEffect(() => {
    getModulesList();
  }, [getModulesList]);

  return (
    <div>
      <Breadcrumbs items={items} />
      <ModuleTable history={history} modulesList={modules} />
    </div>
  );
};

const mapStateToProps = state => ({
  modules: state.modules.allModuleList
});

const mapDispatchToProps = dispatch => ({
  getModulesList: () => dispatch(getAllModuleListAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleList);
